import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input } from 'antd';
import { Button } from '@cropler/ui-kit';
import stylesModal from '../../../styles/modal.module.scss';
import { fieldsApi, useUpdateFieldMutation } from '../../../store/api/fields';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const UpdateFieldForm = ({ t, fields, editedField = { id: '', name: '' }, closeModal }) => {
  const dispatch = useDispatch();
  const [formField] = Form.useForm();
  const [updateField, { isSuccess: isUpdateFieldSuccess }] = useUpdateFieldMutation();

  const validateFieldName = (value) => {
    return fields.find((field) => field.name === value);
  };

  const onUpdateField = (e) => {
    e.preventDefault();
    formField.validateFields().then(() => {});
    const newName = formField.getFieldValue('name');
    if (newName && !validateFieldName(newName)) {
      updateField({ fieldId: editedField.id, name: newName });
      closeModal();
    }
  };

  const onCloseButton = () => {
    formField.resetFields();
    closeModal();
  };

  useEffect(() => {
    formField.setFieldsValue({ name: editedField.name });
  }, []);

  useEffect(() => {
    if (isUpdateFieldSuccess) {
      setTimeout(() => {
        dispatch(fieldsApi.util.resetApiState());
      });
    }
  }, [isUpdateFieldSuccess]);

  return (
    <Form form={formField} layout="vertical" autoComplete="off" requiredMark={false}>
      <Form.Item
        label={t('fields.rename.newName')}
        name="name"
        rules={[
          {
            required: true,
            message: t('fields.add.fieldNamePlaceholder'),
          },
          () => ({
            validator(_, value) {
              if (validateFieldName(value)) {
                return Promise.reject(new Error(`${value} ${t('forms.validation.smthAlreadyExists')}`));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Input type="text" size={'large'} />
      </Form.Item>
      <div className={stylesModal.modalNav}>
        <Button type="secondary" onClick={onCloseButton}>
          {t('actions.cancel')}
        </Button>
        <Button type="primary" onClick={onUpdateField} icon={<CroplerIcon name="check" />}>
          {t('actions.save')}
        </Button>
      </div>
    </Form>
  );
};

export default UpdateFieldForm;
